import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { insightsDetailsGet, messagingInsightsDetailsGet, messageTemplateInsightsDetailsGet, notificationsInsightsDetailsGet, contactsInsightsDetailsGet, messagingPricingInsightsDetailsGet, loadCampaignChartGet, messageTemplateInsightsDetailsRankWiseGet, contactsPositiveLeadsGet, taskDetailsGet, saveActivityPost, updateTaskPatch, addNoteListingPost } from '../Model/DashboardModel';
import Config from '../../../../Utility/Config';

import * as Store from '../../../../storeRedux'


export const insightsDetails = (data) => {
    return get(`${Config.extendedUrl}organisation/phone_number_insights`, data).then((response) => {
        return insightsDetailsGet(response)
    });
};

export const messagingInsightsDetails = (data) => {
    return get(`${Config.extendedUrl}organisation/whatsapp_insights`, data).then((response) => {
        return messagingInsightsDetailsGet(response)
    });
};

export const messagingPricingInsightsDetails = (data) => {
    return get(`${Config.extendedUrl}organisation/pricing_insights`, data).then((response) => {
        return messagingPricingInsightsDetailsGet(response)
    });
};

export const messageTemplateInsightsDetails = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}master_template/list`, data).then((response) => {
        return messageTemplateInsightsDetailsGet(response)
    });
};

export const messageTemplateInsightsDetailsRankWise = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${Config.extendedUrl}organisation/get_master_template_data`, data).then((response) => {
        return messageTemplateInsightsDetailsRankWiseGet(response)
    });
};

export const notificationsInsightsDetails = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}bulk_messages`, data).then((response) => {
        return notificationsInsightsDetailsGet(response)
    });
};

export const contactsInsightsDetails = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}customer`, data).then((response) => {
        return contactsInsightsDetailsGet(response)
    });
};

export const loadCampaignGet = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}bulk_messages/getBroadcastingSummary`, data).then((response) => {
        return loadCampaignChartGet(response)
    });
};

export const contactsPositiveLeads = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}chat_history/list`, data).then((response) => {
        return contactsPositiveLeadsGet(response)
    });
};

export const taskDetails = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}crm_followups/user_task`, data).then((response) => {
        return taskDetailsGet(response)
    });
};

export const saveActivity = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return post(`${FinalUrl}crm_followups/create`, data).then((response) => {
        return saveActivityPost(response)
    });
};

export const updateTask = (id, data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return patch(`${FinalUrl}crm_followups/${id}/status`, data).then((response) => {
        return updateTaskPatch(response)
    })
};

export const addNoteListing = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return post(`${FinalUrl}notes`, data).then((response) => {
        return addNoteListingPost(response)
    })
};